// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FCrsAgwcDIoWNFPG {
  display: flex;
  flex-direction: column;
  padding: 40px;
  width: 100%;
  max-width: 674px;
  height: fit-content;
  background-color: #f2efea;
  border-radius: 24px;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
}

.FCrsAgwcDIoWNFPG .p-dialog-header {
  padding: 0;
  background-color: #f2efea;
  margin-bottom: 24px;
}

.FCrsAgwcDIoWNFPG .p-dialog-title {
  color: #303030;
  font-size: 30px;
  font-weight: 700;
}

.FCrsAgwcDIoWNFPG .p-dialog-header-close {
  width: fit-content;
  height: fit-content;
}

.FCrsAgwcDIoWNFPG .p-dialog-header-close-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.FCrsAgwcDIoWNFPG .p-dialog-content {
  padding: 0;
  background-color: #f2efea;
  margin-bottom: 24px;
}

.FCrsAgwcDIoWNFPG .p-dialog-footer {
  padding: 0;
  background-color: #f2efea;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Chef/components/SendStationStatisticModal/SendStationStatisticModal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B","sourcesContent":[".sendStationStatisticModal {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 40px;\r\n  width: 100%;\r\n  max-width: 674px;\r\n  height: fit-content;\r\n  background-color: #f2efea;\r\n  border-radius: 24px;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.sendStationStatisticModal :global(.p-dialog-header) {\r\n  padding: 0;\r\n  background-color: #f2efea;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.sendStationStatisticModal :global(.p-dialog-title) {\r\n  color: #303030;\r\n  font-size: 30px;\r\n  font-weight: 700;\r\n}\r\n\r\n.sendStationStatisticModal :global(.p-dialog-header-close) {\r\n  width: fit-content;\r\n  height: fit-content;\r\n}\r\n\r\n.sendStationStatisticModal :global(.p-dialog-header-close-icon) {\r\n  width: 18px;\r\n  height: 18px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sendStationStatisticModal :global(.p-dialog-content) {\r\n  padding: 0;\r\n  background-color: #f2efea;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.sendStationStatisticModal :global(.p-dialog-footer) {\r\n  padding: 0;\r\n  background-color: #f2efea;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var sendStationStatisticModal = `FCrsAgwcDIoWNFPG`;
export default ___CSS_LOADER_EXPORT___;
